<template>
  <div class="card p-3">
    <quiz-question
      v-for="(question, key) in questions"
      :key="key"
      :ref="question.id"
      :title="question.title"
      :description="question.description"
      :allowMultiple="question.allowMultiple"
      :choices="question.choices"
      :answers="question.answers"
      :inline="question.inline"
      :show-result="showResult"
      :disabled="disabled"
      v-model="model[question.id]"
    >
    </quiz-question>
    <base-button
      v-if="showSubmit && !submitted"
      @click="submit">
      {{ $t('Submit') }}
    </base-button>
    <base-alert
      v-else-if="submitted"
      type="success"
    >
      Опрос пройден успешно!
    </base-alert>
    <div v-if="!questions">
      <h5>Ожидается правильная схема</h5>
    </div>
  </div>

</template>

<script>
  import QuizQuestion from "./QuizQuestion";
  import {_} from 'vue-underscore';
  export default {
    name: "QuizPreview",
    components: {QuizQuestion},
    computed: {
      questions() {
        return this.schema.questions || []
      },
      selfChecking() {
        return this.schema.selfChecking || this.showSubmit
      },
      disabled() {
        return this.submitted
      }
    },
    props: {
      schema: {
        type: Object,
        required: true
      },
      showSubmit: {
        type: Boolean,
        default: false
      }
    },
    created() {

    },
    data() {
      return {
        model: {},
        showResult: !this.showSubmit,
        tryCount: 0,
        submitted: false,
      }
    },
    methods: {
      emitter(val) {
        if (val) {
          this.$emit("input", val)
        }
      },
      isSuccessQuiz() {
        return _.every(
          _.map(this.questions, question => this.$refs[question.id][0].success),
        )
      },
      refreshModelKeys() {
        this.model = {};
        this.questions.forEach((value => this.model[value.id]));
      },
      submit() {
        if (!this.selfChecking) {
          this.$emit("submit", this.model)
        } else {
          if (!this.isSuccessQuiz()) {
            this.$notify(
              this.$i18n.t('quizPreview.quiz.unsuccessfulSubmitMessage')
            );
            this.tryCount += 1;
            if (this.tryCount === 3) {
              this.showResult = true;
            }
          } else {
            this.$notify(
              this.$i18n.t('quizPreview.quiz.successSubmitMessage')
            );
            this.submitted = true;
            this.$emit("submit", this.model)
          }
        }
      }
    },
    watch: {
      'model': function (val) {
        this.emitter(val)
      },
      'questions': function () {
        this.refreshModelKeys()
      }
    }
  }
</script>

<style scoped>

</style>
